import { useEffect, useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { AlarmClock, MapPin, Clock, Building2, LogIn } from "lucide-react";

export default function NextMissionBanner() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [mission, setMission] = useState(null);
  const role = user?.role;

  useEffect(() => {
    if (role !== "agent" && role !== "gardiennage") return;
    let active = true;
    const load = () => api.get("/planning/my-missions", { params: { all: false } }).then(({ data }) => {
      if (!active) return;
      const list = (data || []).slice().sort((a, b) => (a.date + a.start_time).localeCompare(b.date + b.start_time));
      const today = new Date().toISOString().slice(0, 10);
      const now = new Date().toTimeString().slice(0, 5);
      const todays = list.filter((m) => m.date === today && m.status === "planifiee");
      let next = todays.find((m) => (m.end_time || "23:59") >= now) || todays[0];
      if (!next) next = list.find((m) => m.date > today && m.status === "planifiee") || null;
      setMission(next);
    }).catch(() => {});
    load();
    const t = setInterval(load, 60000);
    return () => { active = false; clearInterval(t); };
  }, [user, role]);

  if ((role !== "agent" && role !== "gardiennage") || !mission) return null;

  const m = mission;
  const today = new Date().toISOString().slice(0, 10);
  const isToday = m.date === today;
  const adresse = [m.site_adresse, [m.code_postal, m.ville].filter(Boolean).join(" ")].filter(Boolean).join(", ");
  const dateLabel = isToday ? "Aujourd'hui" : new Date(m.date + "T12:00:00").toLocaleDateString("fr-FR", { weekday: "long", day: "2-digit", month: "long", timeZone: "Europe/Paris" });

  return (
    <div className="px-4 sm:px-6 pt-4" data-testid="next-mission-banner">
      <div className="rounded-lg border border-[#007AFF]/40 bg-gradient-to-r from-[#007AFF]/15 to-transparent p-4 flex flex-col sm:flex-row sm:items-center gap-3 justify-between">
        <div className="flex gap-3 min-w-0">
          <div className="w-10 h-10 rounded-lg bg-[#007AFF]/20 flex items-center justify-center shrink-0"><AlarmClock className="w-5 h-5 text-[#4da3ff]" /></div>
          <div className="min-w-0">
            <p className="text-[11px] uppercase tracking-wider text-[#4da3ff] font-code">Prochaine mission · {dateLabel}</p>
            <p className="text-white font-medium truncate flex items-center gap-1.5" data-testid="next-mission-title"><Building2 className="w-3.5 h-3.5 text-zinc-400 shrink-0" /> {m.societe_nom} — {m.site_nom}</p>
            <p className="text-sm text-zinc-300 flex flex-wrap items-center gap-x-3 gap-y-0.5 mt-0.5">
              <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5 text-zinc-500" /> {m.start_time}–{m.end_time}</span>
              {adresse && <span className="flex items-center gap-1 min-w-0"><MapPin className="w-3.5 h-3.5 text-zinc-500 shrink-0" /> <span className="truncate">{adresse}</span></span>}
            </p>
          </div>
        </div>
        {m.status === "planifiee" && (
          <Button size="sm" onClick={() => navigate("/dashboard/gardiennage", { state: { mission: m } })} data-testid="next-mission-start" className="bg-[#007AFF] hover:bg-[#3395FF] text-white shrink-0 self-start sm:self-auto">
            <LogIn className="w-4 h-4 mr-1.5" /> Démarrer
          </Button>
        )}
      </div>
    </div>
  );
}
